import { ui } from "@/components/ui";
import { Slider as ShadcnSlider } from "@/components/ui/slider";
import type { InputT } from "@/types/database/forms";
import { useFormContext } from "react-hook-form";
import { cn } from "../../lib/utils";

interface Props {
	input: InputT;
	label: string;
	value: number | null;
	setValue: (value: number) => void;
}

const Slider = (props: Props) => {
	const currentValue = props.value ?? 0;
	const minValue = props.input.min_value ?? 0;
	const maxValue = props.input.max_value ?? 100;
	const form = useFormContext();

	const handleValueChange = (newValue: number) => {
		// Update the form state
		form.setValue(props.input.input_id, newValue, {
			shouldValidate: true,
			shouldDirty: true,
		});
		// Update the entry value
		props.setValue(newValue);
	};

	return (
		<ui.Card className="flex flex-col justify-center items-center gap-4 mx-auto px-0 w-full">
			<ui.CardHeader className="w-full">
				<ui.Label className="w-full font-normal text-md text-slate-800">
					{props.label}
				</ui.Label>
				{props.input.input_description && (
					<ui.FormDescription>
						{props.input.input_description}
					</ui.FormDescription>
				)}
			</ui.CardHeader>
			<ui.CardContent className="flex flex-col gap-y-16 mb-8 w-full">
				<ui.Input
					min={minValue}
					max={maxValue}
					onChange={(e) => handleValueChange(Number(e.target.value))}
					value={Math.round(currentValue).toString()}
					className={cn(
						"flex justify-center items-center m-auto p-auto w-16 h-16 text-4xl text-center [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none [appearance:textfield]",
						maxValue > 10 && "w-40",
					)}
					type="number"
				/>
				<ShadcnSlider
					min={minValue}
					max={maxValue}
					step={1}
					value={[currentValue]}
					onValueChange={([value]) =>
						value !== undefined && handleValueChange(value)}
					className="w-full"
					thumbClassName="h-12 w-12 border-4 border-indigo-500"
				/>
			</ui.CardContent>
			<ui.CardFooter />
		</ui.Card>
	);
};

export default Slider;
